import * as React from 'react';
import { useApplicationContext } from '../../ApplicationContext';
import { PndBanner } from '../../../components/PndBanner';
import { EEventType } from '../../../types/eventEmitter';
import { jsx as _jsx } from "react/jsx-runtime";
export var PndBannerContainer = function PndBannerContainer() {
  var _useApplicationContex = useApplicationContext(),
    config = _useApplicationContex.config,
    emitter = _useApplicationContex.emitter;
  var url = config.get('duplicateOffers.browserUrl') || '';
  var handleLkLinkClick = React.useCallback(function (e) {
    var _e$currentTarget = e.currentTarget,
      href = _e$currentTarget.href,
      target = _e$currentTarget.target;
    e.preventDefault();
    emitter.emit(EEventType.LinkOwnerClick);

    // Устанавливаем таймаут, чтобы успели уйти запросы
    setTimeout(function () {
      return window.open(href, target);
    }, 100);
  }, [emitter]);
  return /*#__PURE__*/_jsx(PndBanner, {
    url: url,
    onLinkClick: handleLkLinkClick
  });
};